<template>
  <CactusAutocomplete
    :multiple="false"
    :api-service="organizationAPI"
    :load-immediate="true"
    label="Organization"
    item-text="name"
    v-bind="$attrs"
    v-model="selected">
  </CactusAutocomplete>
</template>

<script>
import CactusAutocomplete from '@/components/inputs/autocomplete--agnostic.vue'
import OrganizationAPI from '@/api/organization.js'
import {mapState} from 'vuex'
export default {
  components: {
    CactusAutocomplete
  },
  props: {
    setDefaultAsUser: {
      type: Boolean,
      default: false
    },
    value: {
      required: true
    }
  },
  data () {
    return {
      selected: undefined
    }
  },
  computed: {
    ...mapState(['user'])
  },
  created () {
    this.selected = this.value
    this.organizationAPI = OrganizationAPI
    this.setDefault()
  },
  methods: {
    setDefault () {
      if (this.setDefaultAsUser && this.user && this.user.userDetails) {
        this.selected = this.user.userDetails.organization
      }
    }
  },
  watch: {
    value (val) {
      this.selected = val
    },
    selected (val) {
      this.$emit('input', val)
    },
    user (val) {
      this.setDefault()
    }
  }
}
</script>

<style>

</style>
